var _effectorFileName = "/src/page-content/group-lessons/components/pluses-group-lessons/pluses-group-lessons.tsx";
import { useUnit } from 'effector-react';
import { GROUP_LESSONS_PLUSES_LIST } from '@/page-content/group-lessons/constants/pluses-list';
import { Article } from '@/shared/components/article';
import { CardCustom } from '@/shared/components/card-custom';
import { ContactForm } from '@/shared/components/contact-form';
import { $isContactFormSentSuccessfully, contactFormDataSent } from '@/shared/components/contact-form/model';
import { ContactFormData } from '@/shared/components/contact-form/types';
import { TextPlusesList } from '@/shared/components/text-pluses-list';
export const PlusesGroupLessons = () => {
  const {
    isContactFormSentSuccessfully,
    onContactFormSend
  } = useUnit({
    onContactFormSend: contactFormDataSent,
    isContactFormSentSuccessfully: $isContactFormSentSuccessfully
  });
  const handleContactFormSubmit = (data: ContactFormData) => {
    onContactFormSend(data);
  };
  return <Article>
      <h2 className="mb-4 header-h2 sm:mb-8">Плюсы групповых занятий по английскому</h2>

      <div className="grid grid-cols-1 items-center gap-y-6 md:gap-x-20 lg:grid-cols-[1fr_minmax(200px,_50%)] xl:grid-cols-[1fr_minmax(200px,_40%)]">
        <TextPlusesList items={GROUP_LESSONS_PLUSES_LIST} />

        <CardCustom isCardDataSentSuccessfully={isContactFormSentSuccessfully}>
          <ContactForm entryPoint="GROUP_LESSONS_PAGE" buttonText="Записаться на&nbsp;бесплатное занятие" onFormSubmit={handleContactFormSubmit} />
        </CardCustom>
      </div>
    </Article>;
};